module.exports = __webpack_public_path__ + "img/2010 winteressen 025.74a1a0f7.jpg";